import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Header from "../../components/Header";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import CourseItemGrid from "./components/CourseItemsGrid";
import FooterTwo from "../../components/FooterTwo";
import { Styles } from "./styles/course.js";

class CourseGrid extends Component {
  state = {
    activeFilter: "all",
  };

  handleFilterChange = (type) => {
    this.setState({ activeFilter: type });
  };

  render() {
    const { activeFilter } = this.state;

    return (
      <div className="main-wrapper course-page">
        <Header />
        <BreadcrumbBox title="Courses" />

        <Styles>
          <section className="course-grid-area">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12" md="12" sm="12">
                  
                  {/* ===== FILTER BUTTONS ===== */}
                  <Row className="mb-3">
                    <Col className="d-flex justify-content-center">
                      <div
                        style={{
                          display: "flex",
                          gap: "14px",
                          flexWrap: "wrap",
                          justifyContent: "center",
                        }}
                      >
                        {[
                            { label: "All", value: "all" },
                          { label: "Abacus", value: "abacus" },
                          { label: "Kalfun", value: "kalfun" },
                          { label: "Vedic Maths", value: "vedic_maths" },
                        ].map((btn) => {
                          const isActive = activeFilter === btn.value;
                          return (
                            <button
                              key={btn.value}
                              onClick={() =>
                                this.handleFilterChange(btn.value)
                              }
                              style={{
                                padding: "8px 22px",
                                borderRadius: "30px",
                                border: "1.5px solid #ff6f6f",
                                backgroundColor: isActive
                                  ? "#ff6f6f"
                                  : "#fff",
                                color: isActive ? "#fff" : "#ff6f6f",
                                fontWeight: 600,
                                cursor: "pointer",
                              }}
                            >
                              {btn.label}
                            </button>
                          );
                        })}
                      </div>
                    </Col>
                  </Row>

                  {/* ===== COURSE GRID ===== */}
                  <div className="course-items">
                    <Row>
                      <CourseItemGrid activeFilter={activeFilter} />
                    </Row>
                  </div>

                </Col>
              </Row>
            </Container>
          </section>
        </Styles>

        <FooterTwo />
      </div>
    );
  }
}

export default CourseGrid;


// import React, { Component } from 'react';
// import { Container, Row, Col } from 'react-bootstrap';
// import Header from '../../components/Header';
// import { BreadcrumbBox } from '../../components/common/Breadcrumb';
// import CourseSidebar from './components/CourseSidebar';
// import CourseItemGrid from './components/CourseItemsGrid';
// import FooterTwo from '../../components/FooterTwo';
// import { Styles } from './styles/course.js';

// class CourseGrid extends Component {

//     render() {
//         return (
//             <div className="main-wrapper course-page">

//                 {/* Header 2 */}
//                 <Header />

//                 {/* Breadcroumb */}
//                 <BreadcrumbBox title="Courses" />

//                 <Styles>
//                     {/* Course Grid */}
//                     <section className="course-grid-area">
//                         <Container>
//                             <Row>
//                                 {/* <Col lg="3" md="4" sm="5">
//                                     <CourseSidebar />
//                                 </Col> */}
//                                 <Col lg="9" md="8" sm="7">
//                                     <div className="course-items">
//                                         <Row>
//                                             <CourseItemGrid />
//                                         </Row>
//                                     </div>
//                                 </Col>
//                             </Row>
//                         </Container>
//                     </section>
//                 </Styles>

//                 {/* Footer 2 */}
//                 <FooterTwo />

//             </div>
//         )
//     }
// }

// export default CourseGrid